var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c1"},[_c('div',{ref:"cmain1",style:({width: '100%', height: _vm.height,margin:'0 0 0px 0px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }